var React = require('react');

function CheckSquare (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"points":"9 11 12 14 22 4","key":0}),React.createElement("path",{"d":"M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11","key":1})]);
}

CheckSquare.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-check-square"};

module.exports = CheckSquare;

CheckSquare.default = CheckSquare;
